import React from 'react'
import { Theme, useTheme } from '@mui/material'

interface IIconProps {
  width?: string
}

const BetterTournamentIcon: React.FC<IIconProps> = (props) => {
  const theme: Theme = useTheme()
  return (
    <svg
      id='fi_7089269' viewBox='0 0 512 512' fill={theme.palette.text.primary}
      height={props.width} width={props.width} xmlns='http://www.w3.org/2000/svg'
      data-name='Layer 1'
    >
      <path
        d='m498.953 290.044a15.863 15.863 0 0 0 .465-22.146l-1.115-1.214a15.9 15.9 0 0 0 -21.374-1.929l-101.4 76.153a31.5 31.5 0 0 1 3.693 23.218l-.171.643a31.683 31.683 0 0 1 -37.34 23.931l-100.628-21.288a8.4 8.4 0 0 1 -6.4-9.93 8.23 8.23 0 0 1 9.851-6.358l100.628 21.289a15.028 15.028 0 0 0 17.681-11.288l.179-.714a14.887 14.887 0 0 0 -1.95-11.287 14.263 14.263 0 0 0 -9.33-6.573l-141.263-32.151c-18.867-4.286-36.463-.929-52.3 10.216l-68.788 48.225 53.743 80.868 36.076-27.432a8.007 8.007 0 0 1 6.173-1.644l145.717 20.289a27.717 27.717 0 0 0 24.2-8.073l143.662-142.8zm-346.282-52.507a8.311 8.311 0 0 1 -8.3-8.358v-55.865h-22.8a8.3 8.3 0 0 1 -6.715-13.216l50.314-68.866a8.276 8.276 0 0 1 13.416 0l50.324 68.868a8.3 8.3 0 0 1 -6.723 13.216h-22.787v55.865a8.323 8.323 0 0 1 -8.309 8.358zm255.934 0a8.319 8.319 0 0 1 -8.315-8.358v-55.865h-22.79a8.294 8.294 0 0 1 -6.708-13.216l50.3-68.866a8.289 8.289 0 0 1 13.43 0l50.308 68.868a8.294 8.294 0 0 1 -6.708 13.216h-22.789v55.865a8.323 8.323 0 0 1 -8.315 8.358zm-139.218 0h60.913a8.317 8.317 0 0 0 8.308-8.358v-103.3h41.013a8.316 8.316 0 0 0 6.708-13.216l-79.78-109.229a8.269 8.269 0 0 0 -13.409 0l-79.782 109.229a8.32 8.32 0 0 0 6.7 13.216h41.028v103.3a8.306 8.306 0 0 0 8.3 8.358zm-187.64 274.463-73.447-110.655 57.438-38.145 73.445 110.658z'
        fill-rule='evenodd'
      />
    </svg>
  )
}
export default BetterTournamentIcon
